import { r as registerInstance, h, H as Host } from './index-5faac9d7.js';
import { b as brandResources, B as Brand } from './types-66e6568b.js';

const myProductsFooterCss = ".pdf-footer-logo{position:running(pdf-footer-logo);width:94.2px;height:22.6px}.pdf-footer-logo img{width:100%;height:100%}";

const MyProductsFooter = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.date = undefined;
    this.isRTL = undefined;
  }
  render() {
    if (!this.date)
      return;
    return (h(Host, null, h("div", { class: this.isRTL ? 'my-products-rtl-date-format' : 'my-products-ltr-date-format' }, this.date), h("div", { class: "pdf-footer-logo" }, h("img", { src: brandResources[Brand.default].pdfBottomLogo.src, alt: brandResources[Brand.default].pdfBottomLogo.alt })), h("div", { class: this.isRTL ? 'my-products-rtl-page-number' : 'my-products-ltr-page-number' })));
  }
};
MyProductsFooter.style = myProductsFooterCss;

export { MyProductsFooter as pes_my_products_footer };
